import {
  Component,
  OnInit,
  Renderer2,
  OnChanges,
  Output,
  ElementRef,
  EventEmitter,
  ViewChild,
  Input,
  OnDestroy,
  SimpleChanges,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  SecurityContext,
} from '@angular/core'
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms'
import { QuoteDataService } from '../../services/quote-data.service'
import { AuthService } from '@spartacus/core'
import { QuoteCheckoutService } from '../../services/quote-checkout.service'
import { DomSanitizer } from '@angular/platform-browser'
import { CommonService } from '../../../../../shared/services/common.service'

@Component({
  standalone: false,
  selector: 'vs-notification-attachments',
  templateUrl: './notification-attachments.component.html',
  styleUrls: ['./notification-attachments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationAttachmentsComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Output() updateFiles = new EventEmitter<any>()

  notificationAttachmentForm: FormGroup

  @Input() attachments = []
  @ViewChild('fileMaxLenghtExceednotify', { static: false })
  fileMaxLenghtExceednotify: ElementRef
  @ViewChild('fileTypeNotify', { static: false }) fileTypeNotify: ElementRef
  @ViewChild('fileSizeExceedNotify', { static: false })
  fileSizeExceedNotify: ElementRef
  @ViewChild('fileDuplicateNotify', { static: false })
  fileDuplicateNotify: ElementRef
  @ViewChild('fileInfoNotify', { static: false }) fileInfoNotify: ElementRef
  @ViewChild('filenameLengthNotify', { static: false })
  filenameLengthNotify: ElementRef
  @ViewChild('filenameSpecialcharNotify', { static: false })
  filenameSpecialcharNotify: ElementRef
  userType: string
  cartId: string
  showCheckbox: boolean = false
  fileUploadCheck: boolean = false
  specialChar = /[`!@#$%^&*(){}.;,~]/
  constructor(
    private commonService: CommonService,
    private formBuilder: FormBuilder,
    private renderer: Renderer2,
    private quoteDataService: QuoteDataService,
    private auth: AuthService,
    private cd: ChangeDetectorRef,
    private quoteCheckoutService: QuoteCheckoutService,
    private domSanitizer: DomSanitizer
  ) {}

  public myFilesNotification: string[] = []
  public uploadedFiles: any[] = []
  public totalAllFiles: any = 0

  public myFiles: string[] = []
  public disbledBtn

  ngOnInit(): void {
    this.auth.isUserLoggedIn().subscribe((success) => {
      if (success) {
        this.userType = 'current'
        this.cartId = sessionStorage.getItem('cartId-' + this.userType)
      } else {
        this.userType = 'anonymous'
        this.cartId = sessionStorage.getItem('cartId-' + this.userType)
      }
    })
    this.quoteCheckoutService.receiveFilesCount.subscribe((count) => {
      if (count > 0) {
        this.showCheckbox = true
        this.cd.detectChanges()
      } else {
        this.showCheckbox = false
        this.fileUploadCheck = false
        this.cd.detectChanges()
      }
    })
    this.quoteDataService.getAttchments.subscribe((files) => {
      this.attachments = files
      if (this.attachments?.length >= 5) {
        this.disbledBtn = true

        this.cd.detectChanges()
      } else {
        this.disbledBtn = false

        this.cd.detectChanges()
      }

      document
        .querySelectorAll('.fileDivID-sectionnotify')
        .forEach((element) => {
          document.getElementById('fileDivID').remove()
        })
    })
    this.notificationFormDetails()
  }

  notificationFormDetails() {
    this.notificationAttachmentForm = this.formBuilder.group({
      upload: new FormControl('', Validators.required),
    })
  }
  ngOnChanges(changes) {
    if (
      changes?.attachments.previousValue !== changes?.attachments.currentValue
    ) {
      document
        .querySelectorAll('.fileDivID-sectionnotify')
        .forEach((element) => {
          document.getElementById('fileDivID').remove()
        })
    }
  }
  upload(event) {
    this.myFilesNotification = []
    let _this = this
    let filesTotal = 0
    let totalUploadedFiles = 0
    let totalFileSize = 0
    let prevFiles: any = 0

    this.fileMaxLenghtExceednotify.nativeElement.innerHTML = ''
    this.fileTypeNotify.nativeElement.innerHTML = ''
    this.fileSizeExceedNotify.nativeElement.innerHTML = ''
    this.fileDuplicateNotify.nativeElement.innerHTML = ''
    this.filenameLengthNotify.nativeElement.innerHTML = ''
    this.filenameSpecialcharNotify.nativeElement.innerHTML = ''
    const uploadDiv = this.domSanitizer.sanitize(
      SecurityContext.NONE,
      this.fileInfoNotify.nativeElement
    )

    const uploadedFilesCount = document.querySelectorAll(
      '.fileDivID-sectionnotify'
    )
    let allFileNames = []
    // tslint:disable-next-line: prefer-for-of
    for (let j = 0; j < uploadedFilesCount.length; j++) {
      let size = parseInt(uploadedFilesCount[j].getAttribute('data-size'))
      allFileNames.push(uploadedFilesCount[j].getAttribute('data-filename'))
      prevFiles = prevFiles + size
    }
    let isDuplicateFiles = false
    if (event.target.files.length + this.attachments?.length > 5) {
      this.fileMaxLenghtExceednotify.nativeElement.innerHTML =
        'You have exceeded files'
      this.disbledBtn = true
    }
    this.attachments?.forEach((element) => {
      for (var k = 0; k < event.target.files.length; k++) {
        if (element.realFileName == event.target.files[k].name) {
          this.fileDuplicateNotify.nativeElement.innerHTML =
            'File Already exists'
          isDuplicateFiles = true
          this.disbledBtn = false
          return
        }
      }
    })

    let totalSize = prevFiles

    if (
      event.target.files.length <= 5 &&
      event.target.files.length + uploadedFilesCount.length <= 5
    ) {
      if (
        event.target.files.length == 5 ||
        event.target.files.length + uploadedFilesCount.length == 5
      ) {
        this.disbledBtn = true
      }

      for (let a = 0; a < event.target.files.length; a++) {
        totalSize += event.target.files[a].size
        allFileNames.forEach((file) => {
          if (event.target.files[a].name == file) {
            this.fileDuplicateNotify.nativeElement.innerHTML =
              'File Already exists'
            isDuplicateFiles = true
            this.disbledBtn = false
          }
        })
      }
      let filesMB = Math.round((totalSize / (1024 * 1024)) * 100) / 100 // in MB
      if (filesMB <= 30) {
        if (!isDuplicateFiles) {
          for (let i = 0; i < event.target.files.length; i++) {
            if (event.target.files[i].name.trim().length > 30) {
              this.filenameLengthNotify.nativeElement.innerHTML =
                'File name length should not be greater than 30 characters'
              return
            }
            let res_field = event.target.files[i].name
            let extension = res_field
              .substr(res_field.lastIndexOf('.') + 1)
              .toLowerCase()
            let allowedExtensions = ['xlsx', 'doc', 'jpg', 'png', 'pdf', 'jpeg']
            totalSize += event.target.files[i].size
            let file_name = event.target.files[i].name.substring(
              0,
              event.target.files[i].name.lastIndexOf('.')
            )
            if (this.specialChar.test(file_name)) {
              this.filenameSpecialcharNotify.nativeElement.innerHTML =
                'File name should not contain any of the following special characters !@#$%^&*(){}.;,~'
              return
            }
            if (allowedExtensions.indexOf(extension) === -1) {
              this.fileTypeNotify.nativeElement.innerHTML =
                'File format is not supported'
              this.disbledBtn = false
            } else {
              this.uploadedFiles.push({
                filename: event.target.files[i].name,
                filesize: event.target.files[i].size,
              })
              const fileDivNotify = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createElement('div')
              )
              this.renderer.appendChild(uploadDiv, fileDivNotify)
              this.renderer.setAttribute(fileDivNotify, 'id', 'fileDivID')
              this.renderer.setAttribute(
                fileDivNotify,
                'class',
                'fileDivIDUpload'
              )
              this.renderer.setAttribute(
                fileDivNotify,
                'data-size',
                event.target.files[i].size
              )
              this.renderer.setAttribute(
                fileDivNotify,
                'data-filename',
                event.target.files[i].name
              )
              this.renderer.addClass(fileDivNotify, 'fileDivID-sectionnotify')
              const fileIcon = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createElement('i')
              )
              this.renderer.appendChild(fileDivNotify, fileIcon)
              this.renderer.addClass(fileIcon, 'material-icons')
              this.renderer.addClass(fileIcon, 'material-icons-custom')
              const iconText = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createText('receipt')
              )
              this.renderer.appendChild(fileIcon, iconText)
              const fileName = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createElement('p')
              )
              this.renderer.appendChild(fileDivNotify, fileName)
              this.renderer.setAttribute(fileName, 'id', 'para11')
              const fileNameText = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createText(event.target.files[i].name)
              )
              this.renderer.appendChild(fileName, fileNameText)
              const fileSize = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createElement('p')
              )
              this.renderer.appendChild(fileDivNotify, fileSize)
              this.renderer.setAttribute(fileSize, 'id', 'para22')
              const fileNameSize = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createText(
                  // 'Size: ' + Math.round(event.target.files[i].size / 1024) + 'KB'
                  ' ' + this.getFileSize(event.target.files[i].size)
                )
              )
              this.renderer.appendChild(fileSize, fileNameSize)
              const closeIcon = this.renderer.createElement('a')
              this.renderer.appendChild(fileDivNotify, closeIcon)
              this.renderer.setAttribute(closeIcon, 'id', `${i}`)
              this.renderer.setAttribute(
                closeIcon,
                'data-name',
                event.target.files[i].name
              )
              this.renderer.addClass(closeIcon, 'closeId-img')
              const fileNameClose = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createText('x')
              )
              this.renderer.appendChild(closeIcon, fileNameClose)
              closeIcon.addEventListener('click', function (evt) {
                _this.disbledBtn = false
                this.parentElement.remove()
                this.fileMaxLenghtExceednotify.nativeElement.innerHTML = ' '

                for (let z = 0; z < totalUploadedFiles; z++) {
                  if (
                    this.getAttribute('data-name') ==
                    _this.uploadedFiles[z].filename
                  ) {
                    prevFiles = 0
                    _this.uploadedFiles.splice(z, 1)
                    totalUploadedFiles = totalUploadedFiles - 1
                    _this.myFilesNotification.splice(z, 1)
                    // _this.updateFiles.emit(_this.myFilesNotification);
                  }
                }
              })
              if (event.target.files[i].name.trim().length <= 30) {
                this.myFilesNotification.push(event.target.files[i])
                // this.updateFiles.emit(this.myFilesNotification);
                totalUploadedFiles = totalUploadedFiles + 1
              }
            }
          } // for ends
          this.updateFiles.emit(this.myFilesNotification)
        } else {
          ///   'File already exists';
          this.fileDuplicateNotify.nativeElement.innerHTML =
            'File already exists'
        }
      } else {
        //  'file size exceeded';
        this.fileSizeExceedNotify.nativeElement.innerHTML =
          'File Size of all attachment should not exceed 30 MB'
        //'file size exceeded';
        this.disbledBtn = false
      }
    } else {
      //  'You have exceeded files';
      this.fileMaxLenghtExceednotify.nativeElement.innerHTML =
        'You have exceeded files'
    }
    event.target.value = ''
  }

  closeFile(event, mediaFile) {
    const urlparams = [
      'users',
      this.userType,
      'vscart',
      this.cartId,
      'removeAttachment',
    ]

    event.target.parentNode.innerHTML = ' '

    const apiUrl = this.commonService.constructUrl(urlparams)
    this.commonService
      .postData(apiUrl + '?' + 'mediaId=' + mediaFile, {})
      .subscribe((success) => {
        for (let i = 0; i < this.attachments.length; i++) {
          if (mediaFile === this.attachments[i].mediaCode) {
            this.attachments.splice(i, 1)

            if (this.attachments?.length >= 5) {
              this.disbledBtn = true
              this.cd.detectChanges()
            } else {
              this.disbledBtn = false
              this.cd.detectChanges()
            }
          }
        }
      })

    // document.getElementById('hideFile').style.display = 'none';
  }
  getFileSize(fileSize) {
    if (Math.round((fileSize / 1024) * 1000) / 1000 >= 1024.0) {
      return (Math.round(fileSize / 1024) / 1024).toFixed(2) + ' mb'
    }
    if (Math.round((fileSize / 1024) * 1000) / 1000 < 1024.0) {
      return (Math.round((fileSize / 1024) * 1000) / 1000).toFixed() + ' kb'
    }
    // return (fileSize / (1024 * 1024)).toFixed(1) + ' mb';
  }
  getCheckBoxStatus() {
    this.fileUploadCheck = !this.fileUploadCheck
    this.quoteCheckoutService.sendCheckboxFlag(this.fileUploadCheck)
  }
  ngOnDestroy() {
    this.quoteDataService.sendAttachments(null)
  }
}
